<template lang="html">
  <v-app class="large-screen__body white">
    <v-toolbar dark tabs>
      <v-btn icon @click ="goBack">
        <i class="back-icon"></i>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text pb-4">
        FILTERS
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div class="body">
      <v-container fluid class="pa-0">
        <v-layout row wrap class="input-container input-container-top">
          <v-flex xs12 sm2 class="pd-12">
            <label for="Projects">Projects</label>
          </v-flex>
          <v-flex xs12 sm10 class="pa-0">
            <v-select
              class="select"
              solo
              placeholder="Select a Project"
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="input-container input-container-bottom">
          <v-flex xs12 sm2 class="pd-12">
            <label for="Tasks">Effort</label>
          </v-flex>
          <v-flex xs12 sm10 class="pa-0">
            <v-select
              class="select"
              solo
              placeholder="Select a category"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid class="pa-0 pt-3">
        <div ><strong>Channels</strong></div>
        <v-layout row wrap class="pt-3">
          <v-flex xs12 sm11 lg6>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <v-chip small selected><strong>Project • Contributors</strong></v-chip>
              </v-flex>
              <v-flex xs12 sm4>
                <v-chip small selected><strong>Project • Prospects</strong></v-chip>
              </v-flex>
              <v-flex xs12 sm4>
                <v-chip small><strong>Project • Followers</strong></v-chip>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm11 lg6 >
            <v-layout row wrap class="pt-3">
              <v-flex xs12 sm4>
                <v-chip small selected><strong>Effort • Contributors</strong></v-chip>
              </v-flex>
              <v-flex xs12 sm4>
                <v-chip small selected><strong>Effort • Followers</strong></v-chip>
              </v-flex>
              <v-flex xs12 sm4>
                <v-chip small selected><strong>Effort • Prospects</strong></v-chip>
              </v-flex>
          </v-layout>
        </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-app>
</template>

<script>


export default {
  data() {
    return {
    };
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/messages', name: 'Messages' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
    .pd-12 {
      padding-top: 12px;
      padding-left: 15px;
    }
    .input-container-top {
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0px 0px 9px 0 $border-color;
    }
    .input-group__input {
      padding: 0px;
    }
    .input-container-bottom {
      border-radius: 0px 0px 8px 8px;
      box-shadow: 0px 3px 8px 0 $border-color;
    }
    .input-container {
      width: 100%;
      border-color: $border-color;
    }

    .input-container label {
      color: $blue;
      font-size:16px;
      font-family: MuseoSans-500;
    }
  .input-top {
      border-radius: 8px 8px 0px 0px;
      box-shadow: 1px 0px 6px 0 $border-color;
    }

    .input-bottom {
      border-radius: 0px 0px 8px 8px;
      box-shadow: 1px 4px 6px 0 $border-color;
    }

    .toolbar__title {
      text-align: center;
      white-space: initial;
      font-weight: bold;
      margin:0px;
      padding-top: 30px;
    }
    .project-chips {
      .chip__content {
       height: 28px;
     }
   }
    .body {
      padding-top: 30px;
      padding-left: 29px;
      padding-right: 29px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MessagesFilter.vue